"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountSelection = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var asg_1 = require("@alinta-digital/asg");
var StyledAccountSelection_1 = require("./StyledAccountSelection");
/** @component */
var AccountSelection = function (_a) {
    var accounts = _a.accounts, hasCheckbox = _a.hasCheckbox, title = _a.title, boxProps = tslib_1.__rest(_a, ["accounts", "hasCheckbox", "title"]);
    var _b = (0, react_1.useState)(0), width = _b[0], setWidth = _b[1];
    var ref = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(function () {
        var updateWindowDimensions = function () {
            if (ref.current) {
                setWidth(ref.current.children[0].offsetWidth);
            }
        };
        window.addEventListener('resize', updateWindowDimensions);
        return function () { return window.removeEventListener('resize', updateWindowDimensions); };
    }, []);
    var sortByAddress = function (a, b) {
        // by address
        if (a.address < b.address)
            return -1;
        else if (a.address > b.address)
            return 1;
        return 0;
    };
    var sortByFuelType = function (a, b) {
        // by fuel type
        if (a.fuelType < b.fuelType)
            return -1;
        else if (a.fuelType > b.fuelType)
            return 1;
        return 0;
    };
    var accsDual = [];
    var accsSingle = [];
    var accsDualOpen = [];
    var accsDualClosed = [];
    var accsSingleOpen = [];
    var accsSingleClosed = [];
    var accsOpen = [];
    var accsClosed = [];
    var accs = [];
    // dual
    accsDual = accounts.filter(function (acc) { return acc.fuelAccounts.length > 1; });
    accsDualOpen = accsDual.filter(function (acc) {
        // change
        var fa = acc.fuelAccounts.find(function (fa) { return fa.accountStatus !== 'Disconnected'; });
        if (fa !== undefined)
            return true;
    });
    // sort by fuel type
    accsDualOpen.forEach(function (acc) { return (acc.fuelAccounts = acc.fuelAccounts.sort(sortByFuelType)); });
    accsDualClosed = accsDual.filter(function (acc) {
        var fa = acc.fuelAccounts.find(function (fa) { return fa.accountStatus !== 'Disconnected'; });
        if (fa === undefined)
            return true;
    });
    // sort by fuel type
    accsDualClosed.forEach(function (acc) { return (acc.fuelAccounts = acc.fuelAccounts.sort(sortByFuelType)); });
    // single
    accsSingle = accounts.filter(function (acc) { return acc.fuelAccounts.length === 1; });
    accsSingleOpen = accsSingle.filter(function (acc) { return acc.fuelAccounts[0].accountStatus !== 'Disconnected'; });
    accsSingleClosed = accsSingle.filter(function (acc) { return acc.fuelAccounts[0].accountStatus === 'Disconnected'; });
    accsOpen = accsDualOpen.concat(accsSingleOpen).sort(sortByAddress);
    accsClosed = accsDualClosed.concat(accsSingleClosed).sort(sortByAddress);
    accs = accsOpen.concat(accsClosed);
    return (react_1.default.createElement(asg_1.Box, tslib_1.__assign({ maxWidth: "720px", margin: { horizontal: 'auto' } }, boxProps),
        react_1.default.createElement(asg_1.Heading, { level: "4", weight: 600, margin: "0" }, title),
        accs.map(function (account, accountIdx, accountsArray) {
            var isNotAccount = accountIdx !== accountsArray.length - 1;
            return (react_1.default.createElement("div", { key: "accounts-".concat(accountIdx) },
                react_1.default.createElement(asg_1.Box, { margin: { top: '24px', bottom: '48px' } },
                    account.accountType && react_1.default.createElement(StyledAccountSelection_1.StyledAccounttype, null, account.accountType),
                    react_1.default.createElement(asg_1.Heading, { level: "5", weight: 500, margin: { top: '0', bottom: '24px' } }, account.address),
                    account.fuelAccounts.length === 2 && (react_1.default.createElement(StyledAccountSelection_1.StyledAddressContainerBox, { ref: ref, width: "100%" },
                        react_1.default.createElement(asg_1.Tile, { checkbox: hasCheckbox, checked: account.fuelAccounts[0].checked, type: "fuel", "data-testid": "account-tile-".concat(account.fuelAccounts[0].accountNumber), fuelContent: {
                                fuelType: account.fuelAccounts[0].fuelType,
                                accountNumber: account.fuelAccounts[0].accountNumber,
                            }, onClick: function () {
                                return account.fuelAccounts[0].onClick(account.fuelAccounts[0].accountNumber.replace(/ /g, ''));
                            }, accountStatus: account.fuelAccounts[0].accountStatus }),
                        react_1.default.createElement(asg_1.Box, { className: "gap", width: "32px" }),
                        react_1.default.createElement(asg_1.Tile, { className: "addressWrapper", checkbox: hasCheckbox, checked: account.fuelAccounts[1].checked, type: "fuel", "data-testid": "account-tile-".concat(account.fuelAccounts[1].accountNumber), fuelContent: {
                                fuelType: account.fuelAccounts[1].fuelType,
                                accountNumber: account.fuelAccounts[1].accountNumber,
                            }, onClick: function () {
                                return account.fuelAccounts[1].onClick(account.fuelAccounts[1].accountNumber.replace(/ /g, ''));
                            }, accountStatus: account.fuelAccounts[1].accountStatus }))),
                    account.fuelAccounts.length === 1 && (react_1.default.createElement(StyledAccountSelection_1.StyledAddressContainerBox, { width: "100%" },
                        react_1.default.createElement(asg_1.Tile, { checkbox: hasCheckbox, checked: account.fuelAccounts[0].checked, width: width === 0 ? undefined : "".concat(width, "px"), type: "fuel", "data-testid": "account-tile-".concat(account.fuelAccounts[0].accountNumber), fuelContent: {
                                fuelType: account.fuelAccounts[0].fuelType,
                                accountNumber: account.fuelAccounts[0].accountNumber,
                            }, onClick: function () {
                                return account.fuelAccounts[0].onClick(account.fuelAccounts[0].accountNumber.replace(/ /g, ''));
                            }, accountStatus: account.fuelAccounts[0].accountStatus }),
                        width === 0 && (react_1.default.createElement(react_1.default.Fragment, null,
                            react_1.default.createElement(asg_1.Box, { className: "gap", width: "32px" }),
                            react_1.default.createElement(asg_1.Box, { className: "filler" })))))),
                isNotAccount && react_1.default.createElement(asg_1.Divider, null)));
        })));
};
exports.AccountSelection = AccountSelection;
//# sourceMappingURL=AccountSelection.js.map